<template>
  <table class="regattas-table table table-bordered text-nowrap">
    <thead class="thead-dark">
      <tr class="text-center">
        <th colspan="5">Регата</th>
        <th colspan="2">Игрок</th>
      </tr>
      <tr>
        <th>ид</th>
        <th>аудитория</th>
        <th>статус</th>
        <th>начало</th>
        <th>конец</th>
        <th>присоединение</th>
        <th>заезды</th>
      </tr>
    </thead>
    <tr
      v-for="regatta in regattas"
      :key="regatta.regatta.id"
      :class="getRegattaClass(regatta.regatta.status)"
    >
      <td>
        <regatta-link :regattaId="regatta.regatta.id"/>
      </td>
      <td>
        {{ getRegattaAudienceNameVerbose(regatta.regatta.audience) }}
      </td>
      <td :class="getRegattaStatusClass(regatta.regatta.status)">
        {{ getStatusName(regatta.regatta.status) }}
      </td>
      <td>
        {{ getMomentStr(regatta.regatta.start_at) }}
      </td>
      <td>
        {{ getMomentStr(regatta.regatta.finish_at) }}
      </td>
      <td>
        {{ getMomentStr(regatta.joinTime) }}
      </td>
      <td class="text-right">
        {{ regatta.roundAmount }}
      </td>
    </tr>
  </table>
</template>

<script>
import RegattaLink from './RegattaLink.vue';

import { getRegattaClass               } from '../../model/regatta.js';
import { getRegattaStatusClass         } from '../../model/regatta.js';
import { getRegattaAudienceNameVerbose } from '../../model/regatta.js';
import { Regatta                       } from '../../model/regatta.js';

import { getMomentStr } from '../../util.js';

export default {
  name: 'PlayerRegattasTable',

  components: {
    RegattaLink,
  },

  props: {
    playerId: {
      type: Number,
      required: true,
    },

    regattas: {
      type: Array,
      required: true,
    },
  },

  methods: {
    getRegattaClass,
    getRegattaStatusClass,
    getRegattaAudienceNameVerbose,
    getStatusName: Regatta.getStatusName,
    getMomentStr,
  },
}
</script>

<style scoped>
.regattas-table {
  width: 1px;
}
</style>
